import { render, staticRenderFns } from "./FormBuild.vue?vue&type=template&id=28a3b0d7&scoped=true&"
import script from "./FormBuild.vue?vue&type=script&lang=js&"
export * from "./FormBuild.vue?vue&type=script&lang=js&"
import style0 from "./FormBuild.vue?vue&type=style&index=0&id=28a3b0d7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a3b0d7",
  null
  
)

export default component.exports